const ANALYTICS_CONSTANTS = {
  bannerSearchClick: 'banner:click search',
  featuredProducts: 'featured products',
  topMatchingProducts: 'top matching products',
  previousProducts: 'previous products',
  trendingSearch: 'trending search',
};

export default ANALYTICS_CONSTANTS;
